import React from 'react';
import { Route } from 'react-router-dom';
import Employees from '../pages/employees/Employees';
import EmployeesArchive from '../pages/employees/EmployeesArchive';
import CreateEmployee from '../pages/employees/CreateEmployee';
import EditEmployee from '../pages/employees/EditEmployee';
import PermissionGuard from '../components/global/PermissionGuard';

const employeesRoutes = (
    <>
        <Route path="/employees" element={<PermissionGuard permission="employees_list"><Employees /></PermissionGuard>} />
        <Route path="/employees/archive" element={<PermissionGuard permission="employees_archive_list"><EmployeesArchive /></PermissionGuard>} />
        <Route path="/employees/create" element={<PermissionGuard permission="employees_create"><CreateEmployee /></PermissionGuard>} />
        <Route path="/employees/:id/edit" element={<PermissionGuard permission="employees_edit"><EditEmployee /></PermissionGuard>} />
    </>
);

export default employeesRoutes;
